import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import StoreCarts from "./storeCarts";
import RestaurantCarts from "./restaurantCart";

const tabs = [
  { name: "Food Cart", href: "food" },
  { name: "Merchandise Cart", href: "merchandise" },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function CartsStore() {
  const navigate = useNavigate();
  const DEFAULT_ACTIVE_TAB = "food";
  const { active_tab } = useParams();

  useEffect(() => {
    if (!active_tab) {
      navigate(`/admin/:name/carts/${DEFAULT_ACTIVE_TAB}`);
    }
  });

  const toggle = (tab) => {
    if (active_tab !== tab) {
      navigate(`/admin/:name/carts/${tab.href}`);
    }
  };

  return (
    <div data-test="store-cart">
      <div className="mb-8">
        <h1 className="text-3xl font-semibold text-gray-900">Carts</h1>
      </div>

      <div className="sm:block">
        <div className="border-b border-gray-200">
          <nav
            className="-mb-px flex space-x-8 overflow-x-auto"
            aria-label="Tabs"
          >
            {tabs.map((tab) => (
              <button
                key={tab.name}
                onClick={() => {
                  toggle(tab);
                }}
                className={classNames(
                  tab.href === active_tab
                    ? "border-primary text-primary font-bold"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300",
                  "whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm"
                )}
                aria-current={tab.href === active_tab ? "page" : undefined}
              >
                {tab.name}
              </button>
            ))}
          </nav>
        </div>
      </div>

      <div className="mt-4">
        {active_tab === "food" && <StoreCarts />}
        {active_tab === "merchandise" && <RestaurantCarts />}
      </div>
    </div>
  );
}
